/** View names - must match backend VIEW_REGISTRY keys */
export type ViewName = 'inbox' | 'jobs' | 'job-id-search' | 'backend-api';

export const VIEW_NAMES = {
  INBOX: 'inbox' as const,
  JOBS: 'jobs' as const,
  JOB_ID_SEARCH: 'job-id-search' as const,
  BACKEND_API: 'backend-api' as const,
} as const;

export interface ViewSelectionParams {
  jobIds?: string[] | null;
  search?: string | null;
  explicitView?: ViewName;
}

/** Selects view based on filter parameters */
export function selectView(params: ViewSelectionParams): ViewName {
  if (params.jobIds && params.jobIds.length > 0) {
    return VIEW_NAMES.JOB_ID_SEARCH;
  }
  if (params.explicitView) {
    return params.explicitView;
  }
  return VIEW_NAMES.JOBS;
}

export function isInboxView(view: ViewName): boolean {
  return view === VIEW_NAMES.INBOX;
}

export function supportsPinnedJobs(view: ViewName): boolean {
  return view === VIEW_NAMES.INBOX;
}

export function supportsSmartSort(view: ViewName): boolean {
  return view === VIEW_NAMES.INBOX;
}

/**
 * Cache defaults for React Query keys.
 * These defaults must be included in query keys so that live update cache matching
 * works correctly (shouldInboxConsumeUpdate compares against query key filters).
 * The backend also uses these defaults via job-view-schemas.js.
 */
export const VIEW_CACHE_DEFAULTS: Partial<
  Record<ViewName, Record<string, unknown>>
> = {
  inbox: { isOpen: true }, // Required for live update filter matching
  // Mirror jobsViewSchema.defaults on the server (HMB-19199).
  jobs: { sort: 'createdAt', order: 'DESC' },
  'job-id-search': {},
  'backend-api': {},
} as const;

export function getViewCacheDefaults(view: ViewName): Record<string, unknown> {
  return VIEW_CACHE_DEFAULTS[view] || {};
}
